export const formatXAxis = (tickFormat: any) => {
  return tickFormat !== 0 ? tickFormat / 1000 + "" : '0';
};
